import { Badge } from "@/components/ui/badge";
import { Invoice } from "@/types";

function InvoiceStatusBadge({ status }: { status: Invoice["status"] }) {
  return (
    <Badge variant={status === "paid" ? "default" : "secondary"}>
      {status === "paid" ? "Paid" : "Pending"}
    </Badge>
  );
}

export default InvoiceStatusBadge;
